import { HttpEvent, HttpEventType, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { HandleSuccessService } from './handle-success.service';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const globalSuccessInterceptor = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const handleSuccessService = inject(HandleSuccessService);
  const requestMethod = req.method;
  const requestUrl = req.url

  // Response
  return next(req).pipe(
    tap((event: HttpEvent<any>) => {
      // Check if the event is an HttpResponse to ensure it's a response
      if (event.type === HttpEventType.Response) {
        if (requestMethod == 'POST' || requestMethod == 'PUT' || requestMethod == 'DELETE') {
          handleSuccessService.handleSuccess(event,requestMethod,requestUrl);
        }
      }
    }),
  );
};
